import React from 'react'
import { FiCheck } from 'react-icons/fi'

const PASOS = ['Elige tus talleres', 'Revisa tu carrito', 'Confirma y paga']

/**
 * Indicador del flujo de inscripción. `actual` es el índice (0-based) del paso en curso:
 * los anteriores salen completados en azul y el actual en amarillo.
 */
export default function PasosCompra({ actual = 0 }) {
    return (
        <ol className="flex items-center gap-2 sm:gap-3 mb-8" aria-label="Pasos de la inscripción">
            {PASOS.map((paso, i) => {
                const hecho = i < actual
                const enCurso = i === actual
                return (
                    <li key={paso} className="flex items-center gap-2 sm:gap-3 min-w-0 flex-1 last:flex-none"
                        aria-current={enCurso ? 'step' : undefined}>
                        <span className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center text-sm font-extrabold transition-colors
                            ${hecho ? 'bg-primary text-white'
                                : enCurso ? 'bg-secondary text-[#00266b] ring-4 ring-secondary/30'
                                    : 'bg-white text-gray-400 border border-gray-200'}`}>
                            {hecho ? <FiCheck size={15} strokeWidth={3} /> : i + 1}
                        </span>
                        <span className={`text-sm font-semibold truncate ${enCurso ? 'text-gray-900' : hecho ? 'text-primary' : 'text-gray-500'}
                            ${enCurso ? '' : 'hidden sm:inline'}`}>
                            {paso}
                        </span>
                        {i < PASOS.length - 1 && (
                            <span aria-hidden className={`h-0.5 flex-1 rounded-full min-w-[16px] ${hecho ? 'bg-primary' : 'bg-gray-200'}`} />
                        )}
                    </li>
                )
            })}
        </ol>
    )
}
